'use client'

import { ReloadIcon } from '@radix-ui/react-icons'
import { useFormStatus } from 'react-dom'
import { Button, type ButtonProps } from './button'

type SubmitButtonProps = {
  className?: string
  loadingText?: string
  actionText?: string
  disabled?: boolean
  size?: ButtonProps['size']
}

export const SubmitButton = ({
  size,
  className,
  loadingText,
  actionText,
  disabled,
}: SubmitButtonProps) => {
  const status = useFormStatus()

  return (
    <Button type="submit" className={className} size={size} disabled={status.pending || disabled}>
      {status.pending ? (
        <>
          <ReloadIcon className="mr-2 h-4 w-4 animate-spin" /> {loadingText}
        </>
      ) : (
        actionText
      )}
    </Button>
  )
}
